import createChainedFunction from '@mui/utils/createChainedFunction';
export default createChainedFunction;